import { SVGProps } from "react";

export const PYUSDIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 84.3 84.9" {...props}>
    <path
      fill="#0071F3"
      d="M42.1,84.9c23.3,0,42.1-19,42.1-42.4C84.3,19,65.4,0,42.1,0C18.9,0,0,19,0,42.4C0,65.9,18.9,84.9,42.1,84.9z"
    />
    <path
      fill="#FFFFFF"
      d="M48.8,17h-4.6H34c-1.6,0-3.1,1.2-3.3,2.9l-1,6.8v0.1h-5c-1.3,0-2.4,1.1-2.4,2.4c0,1.4,1.1,2.4,2.4,2.5h4.2
      l-0.7,4.7l0,0.4h-5c-1.3,0-2.4,1.1-2.4,2.4c0,1.3,1.1,2.4,2.4,2.4h4.2l-2.3,14.6l-0.7,4.9l-0.4,2.6c-0.3,2.1,1.2,3.9,3.3,3.9h3.2
      h4.4h3.6c1.6,0,3-1.2,3.3-2.9l2.1-13.4h1.2h4c9.4,0,17.1-7.8,16.9-17.3C65.9,24.3,58.1,17,48.8,17z M33.8,31.5l15,0.1
      c1.3,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5H33L33.8,31.5z M48.9,46.1h-2.5h-1.2h-2.5c-1.6,0-3,1.2-3.3,2.9l-2.1,13.4H29l3.2-21
      h16.6c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3l-14.2-0.1l0.7-4.8h13.8c6.8,0,12.2,5.6,12.1,12.4C61,40.9,55.5,46.1,48.9,46.1z"
    />
  </svg>
);
